import { render, staticRenderFns } from "./CreateCouponComponent.vue?vue&type=template&id=77bfe36a"
import script from "./CreateCouponComponent.vue?vue&type=script&lang=js"
export * from "./CreateCouponComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports